// After-Sales Service page Indonesian translations

export default {
  pageTitle: "Layanan Purnajual",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Layanan Purnajual",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Layanan Purnajual Komprehensif",
  description1: "Di PT Eagle Industry Indonesia, komitmen kami terhadap kepuasan pelanggan melampaui pembelian awal. Program layanan purnajual komprehensif kami memastikan bahwa Anda menerima dukungan berkelanjutan sepanjang siklus hidup produk kami, memaksimalkan kinerja mereka dan memperpanjang umur layanan.",
  description2: "Kami percaya bahwa hubungan pelanggan jangka panjang dibangun di atas dukungan yang andal dan pengiriman layanan yang konsisten. Tim purnajual kami didedikasikan untuk memberikan bantuan segera, pemeliharaan teratur, dan solusi proaktif untuk mencegah masalah sebelum memengaruhi operasi Anda.",
  
  // Services section
  servicesTitle: "Penawaran Layanan Purnajual Kami:",
  services: [
    "Penjadwalan pemeliharaan teratur dan pemantauan kinerja",
    "Manajemen suku cadang dan pengiriman dipercepat",
    "Program inspeksi peralatan dan pemeliharaan preventif",
    "Layanan peningkatan dan retrofit produk",
    "Manajemen garansi dan pemrosesan klaim",
    "Program pelatihan pelanggan untuk operasi dan pemeliharaan yang tepat",
    "Pelacakan kinerja dan rekomendasi optimasi"
  ],
  
  // Maintenance programs section
  maintenanceTitle: "Program Pemeliharaan:",
  maintenanceDescription: "Program pemeliharaan terstruktur kami dirancang untuk mengidentifikasi masalah potensial sebelum menyebabkan kegagalan peralatan. Kami menawarkan jadwal pemeliharaan yang disesuaikan berdasarkan kondisi operasional, pola penggunaan, dan kritikalitas aplikasi. Program ini mencakup inspeksi rinci, pengujian kinerja, dan penggantian komponen aus untuk memastikan operasi yang andal secara berkelanjutan.",
  
  // Metrics
  serviceAvailability: "Ketersediaan Layanan",
  serviceAvailabilityDesc: "Jaringan dukungan komprehensif dengan pusat layanan regional",
  responseEfficiency: "Efisiensi Respon",
  responseEfficiencyDesc: "Waktu perputaran cepat untuk pemeliharaan dan perbaikan",
  spareParts: "Suku Cadang",
  sparePartsDesc: "Inventaris strategis memastikan ketersediaan suku cadang segera",
  customerSatisfaction: "Kepuasan Pelanggan",
  customerSatisfactionDesc: "Manajer akun yang didedikasikan untuk layanan personal",
  
  // Service contracts section
  serviceContractsTitle: "Kontrak Layanan:",
  serviceContractsDescription: "Kami menawarkan kontrak layanan fleksibel yang disesuaikan dengan kebutuhan operasional spesifik dan persyaratan anggaran Anda. Kontrak layanan kami dapat mencakup kunjungan pemeliharaan teratur, layanan respons darurat, penggantian suku cadang, dan jaminan kinerja. Kontrak ini menyediakan solusi hemat biaya sambil memastikan kinerja dan keandalan peralatan optimal.",
  
  // Customer feedback section
  customerFeedbackTitle: "Integrasi Umpan Balik Pelanggan:",
  customerFeedbackDescription: "Kami menghargai umpan balik pelanggan sebagai komponen penting dari proses peningkatan berkelanjutan kami. Tim layanan purnajual kami secara teratur mengumpulkan dan menganalisis umpan balik pelanggan untuk mengidentifikasi peluang peningkatan layanan dan perbaikan produk. Pendekatan berpusat pada pelanggan ini memastikan bahwa layanan kami berkembang untuk memenuhi kebutuhan pasar yang berubah dan melampaui ekspektasi.",
  
  // CTA button
  requestSupport: "Minta Dukungan Purnajual",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  technicalSupportDesc: "Bantuan teknis ahli untuk memastikan kinerja produk optimal.",
  qualityAssuranceDesc: "Proses kontrol kualitas ketat memastikan kepatuhan standar internasional.",
  globalSupplyChainDesc: "Jaringan distribusi global yang efisien memastikan pengiriman produk tepat waktu.",
  readMore: "Baca selengkapnya"
};